import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TablePagination, TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import Table from 'src/components/Table';
import WithholdingsRow from './WithholdingsRow';

if (!process.env.REACT_APP_TABLE_SIZE) {
  console.error(
    'REACT_APP_TABLE_SIZE variable not loaded properly. Check your .env file please!'
  );
}

const Tbody = ({ withholdings }) =>
  withholdings.map(withholding => (
    <WithholdingsRow key={withholding.id} {...withholding} />
  ));

const WithholdingsTable = ({
  className,
  withholdings,
  count,
  page,
  handleChangePage,
  loading,
  ...rest
}) => {
  const { t } = useTranslation();

  const theads = useMemo(() => () => (
    <TableRow component="tr">
      <TableCell style={{ width: '14%' }} align="center">
        {t('COMMON.DATE')}
      </TableCell>
      <TableCell style={{ width: '12%' }} align="center">
        {t('CFDI_VIEWS.DIVIDENDS')}
      </TableCell>
      <TableCell style={{ width: '12%' }} align="center">
        {t('CFDI_VIEWS.OTHER_WITHHOLDINGS')}
      </TableCell>
      <TableCell style={{ width: '12%' }} align="center">
        {t('CFDI_VIEWS.INCOME_TOTAL')}
      </TableCell>
    </TableRow>
  ));

  const tbody = useMemo(() => () => <Tbody withholdings={withholdings} />, [
    withholdings
  ]);

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
        labelDisplayedRows={({ from, to, count: c }) => {
          return `${from}-${to} ${t('COMMON.OF')} ${c}`;
        }}
      />
    ),
    [page, withholdings]
  );

  return (
    <Table
      {...rest}
      tbody={tbody}
      theads={theads}
      pagination={pagination}
      loading={loading}
    />
  );
};

WithholdingsTable.propTypes = {
  className: PropTypes.string,
  withholdings: PropTypes.array.isRequired,
  count: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  loading: PropTypes.bool
};

WithholdingsTable.defaultProps = {
  count: 0
};

export default WithholdingsTable;
